import { useForm, Controller } from "react-hook-form";
import { SdsForm, SmartSoftButton } from "soft_digi";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import { ADMIN_USER_LOGO } from "../../../services/ImageService";
import { get, post } from "../../../services/smartApiService";
import { showAlertAutoClose } from "../../../services/notifyService";
import { USER_URLS } from "../../../api/AdminUrls";
import { useEffect, useRef, useState } from "react";
import { EMPLOYEE_URLS } from "../../../api/EmployeeUrls";

const validationSchema = Yup.object({
  currentPassword: Yup.string().required("Current Password is required"),
  newPassword: Yup.string()
    .required("New Password is required"),
    // .min(8, "New Password must be at least 8 characters"),
    // .matches(/[A-Z]/, "New Password must contain at least one uppercase letter")
    // .matches(/[a-z]/, "New Password must contain at least one lowercase letter")
    // .matches(/[0-9]/, "New Password must contain at least one number")
    // .matches(
    //   /[@$!%*?&#]/,
    //   "New Password must contain at least one special character"
    // ),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("newPassword")], "Passwords must match"),
});
interface FormData {
  profile_img?: any | null;
}
const Profile = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });


  
  const [formData, setFormData] = useState<FormData>({ profile_img: null });

  const fileInputRef = useRef<HTMLInputElement | null>(null);





  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          profile_img: reader.result as string,
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  const onSubmit = (data: any) => {
   
    let url = USER_URLS.CHANGE_PASSWORD;
    const subscription = post(url, data).subscribe(
      (response) => {
     
         showAlertAutoClose("Password Changed Successfully","success" );
         setTimeout(() => {
          window.scrollTo(0, 0);
        }, 2500);
        
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  // useEffect(() => {
  //   const fetchProfileImage = () => {
  //     try {
  //       const response = get(USER_URLS.GET_ONE_IMAGE)
  //       if (response && response.profile_img) {
  //         setFormData({ profile_img: `data:image/png;base64,${response.profile_img}` });
  //       }
  //     } catch (error) {
  //       // console.error("Error fetching profile image:", error);
  //     }
  //   };
  //   fetchProfileImage();
  // }, []);
  const onSubmit_Profile = () => {
    let url = USER_URLS.PROFILE_UPDATE;
    const payload = {
      ...formData,
      profile_img: formData.profile_img?.split(",")[1] || null,
    };
    const subscription = post(url, payload).subscribe(() => {
    });
    return () => subscription.unsubscribe();
  };
 
  
  const LoginSettings = () => {
    const elements: SdsFormElementProps[] = [
      {
        type: "PASSWORD",
        width: 12,
        name: "currentPassword",
        element: {
          label: "Current Password",
          inputType: "BORDER_LABEL",
          isRequired: true,
        },
      },
      {
        type: "PASSWORD",
        width: 12,
        name: "newPassword",
        element: {
          label: "New Password",
          inputType: "BORDER_LABEL",
          isRequired: true,
        },
      },
      {
        type: "PASSWORD",
        width: 12,
        name: "confirmPassword",
        element: {
          label: "Confirm Password",
          inputType: "BORDER_LABEL",
          isRequired: true,
        },
      },

      {
        type: "BUTTON",
        width: 12,
        name: "submit",
        class_name: "has-text-right",
        element: { label: "Submit", onClick: handleSubmit(onSubmit),  classList: ["button", "smart-action-button"], },
      },
    ];
    return (
      <>
     
            <div className="mt-3 sd-hims-input">
              <SdsForm elements={elements} errors={errors} control={control} />
            </div>
         
      </>
    );
  };

  return (
    <>
      <div className="is-size-4 smart-efl-table_main_container">
        <p>Profile</p>
      </div>
      <div className="sd-efl-input mt-6 p-3">
        <div className="columns is-multiline">
          {/* Profile Image Column */}
          <div className="column is-4  ">
          <div className="profile-header">
                        <div className="is-flex is-justify-content-center is-align-items-center is-rounded">
                          <img
                            src={formData.profile_img || ADMIN_USER_LOGO}
                            alt="Profile"
                            className="image is-128x128 is-rounded"
                          />
                        </div>
                        <div className="smart-crop-image-edit">
                          <i
                            className="fa fa-pencil image-edit-options is-size-6"
                            onClick={() => fileInputRef.current?.click()} title="Upload Image"
                          ></i>
                          <input
                            type="file"
                            ref={fileInputRef}
                            className="hidden"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                      <div className="mt-5 is-flex is-justify-content-center is-align-items-center ">
                                  <SmartSoftButton
                                    label="Update"
                                    onClick={onSubmit_Profile}
                                    classList={["is-small"]}
                                  />
                                </div>     
          </div>
       
          <div className="user-info column is-4 ">
            {/* <table className="table ">
              <tr>
                <td>Name:</td>
                <td>ADMIN</td>
              </tr>
              <tr>
                <td>Email:</td>
                <td>Admin@gmail.com</td>
              </tr>
            </table> */}
          </div>
          <div className="column is-4">{LoginSettings()}</div>
        </div>
      </div>
    </>
  );
};

export default Profile;
